export const YYYY_MM_DD_FORMAT = "YYYY-MM-DD";
export const YYYY_MM_DD_HH_MM_MS_FORMAT = "YYYY-MM-DD HH:mm:ss";
